import pluralize from 'pluralize';
import { encode } from 'base64-arraybuffer';

import { getActualDate, getDateDifference, getFormattedDate } from './time';

import { MAX_NUMBER_OF_FILES } from '../constants/validations';
import { OPERATIONS } from '../constants/product';

export function fileToArrayBuffer(file) {
  return new Promise(function read(resolve, reject) {
    const reader = new FileReader();

    reader.addEventListener('error', function onError(event) {
      reject(event.target.error);
    });

    reader.addEventListener('loadend', function onloadEnd(event) {
      resolve(event.target.result);
    });

    reader.readAsArrayBuffer(file);
  });
}

export async function fileToBase64(file) {
  const { type } = file;
  const data = await fileToArrayBuffer(file);
  return `data:${type};base64,${encode(data)}`;
}

export function formatTimestamp(timestamp) {
  const updated = 'Updated';

  if (timestamp === undefined) return `${updated} just now`;

  const date = new Date(timestamp);
  const today = getActualDate();
  const { days, hours, minutes, months, seconds, years } = getDateDifference(today, date);

  if (years || months || days) {
    return `${updated} ${getFormattedDate(timestamp)}`;
  } else if (hours) {
    return `${updated} ${pluralize('hour', hours, true)} ago`;
  } else if (minutes) {
    return `${updated} ${pluralize('minute', minutes, true)} ago`;
  } else if (seconds) {
    return `${updated} just now`;
  } else {
    return `${updated} while ago`;
  }
}

export function filesNumberLimitReached({ channel, files, operationType, productFiles, startIndex }) {
  switch (operationType) {
    case OPERATIONS[channel].FILES.ADD: {
      return productFiles.size + files.length === MAX_NUMBER_OF_FILES[channel];
    }

    case OPERATIONS[channel].FILES.REPLACE: {
      return startIndex + files.length === MAX_NUMBER_OF_FILES[channel];
    }

    default: {
      return false;
    }
  }
}

export function formatFileName(file) {
  return file instanceof File
    ? new File([file], file.name.replace(/\s+/g, ''), file)
    : file;
}

export function downloadFile({ data, name }) {
  const a = document.createElement('a');
  a.style = 'display: none';
  a.href = data;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
